
/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import Slider from '@mui/material/Slider';
import weightarrow from '../assets/weight-arrow.png';
import frontimg from '../assets/front-girl 1-01.png';
import backimg from '../assets/back-girl 4-01.png';
import sideimg from '../assets/side girl 3-01.png';
import stomachimg from '../assets/stomach girl.png';
import thighsimg from '../assets/girl leg-01.png';
import avacado from '../assets/avocado.png';
import apple from '../assets/apple.png';
import zucchini from '../assets/zucchini.png';
import pear from '../assets/pear.png';
import tomato from '../assets/tomato.png';
import carrot from '../assets/carrot.png';
import corn from '../assets/corn.png';
import pineapple from '../assets/pineapple.png';
import finger from '../assets/finger-img.png';
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from "../Components/CustomDatePicker";
import imageCompression from 'browser-image-compression';

/** BMI under 19 + weight loss: show health notice (does not block form progress) */
const UNDERWEIGHT_LOSS_NOT_ALLOWED_MESSAGE =
    "Deine Gesundheit steht für uns an erster Stelle. Bei einem BMI unter 19 ist eine weitere Gewichtsabnahme in der Regel nicht empfehlenswert. Umso wichtiger ist es uns, dass Du Dich gut begleitet und sicher fühlst.\n\nMelde Dich gerne direkt bei uns unter support@goldenbody.ch – wir sind für Dich da und finden gemeinsam einen Weg, der zu Dir passt und Deine Gesundheit in den Mittelpunkt stellt.";

function computeBmi(heightCm, weightKg) {
    const height = parseFloat(heightCm);
    const weight = parseFloat(weightKg);
    if (Number.isNaN(height) || Number.isNaN(weight) || height <= 0 || weight <= 0) {
        return null;
    }
    const heightInMeters = height / 100;
    return weight / (heightInMeters * heightInMeters);
}

function isUnderweightLossBlocked(bmiVal, currentStr, targetStr) {
    const bmiNum = typeof bmiVal === "number" ? bmiVal : parseFloat(bmiVal);
    const current = parseFloat(currentStr);
    const target = parseFloat(targetStr);
    return (
        !Number.isNaN(bmiNum) &&
        bmiNum < 19 &&
        !Number.isNaN(current) &&
        !Number.isNaN(target) &&
        target < current
    );
}

function parseSliderWeeks(value, fallback = 10) {
    const parsed = parseInt(value, 10);
    return parsed >= 1 && parsed <= 52 ? parsed : fallback;
}

const Form = ({ label, name, value, onChange, onSliderChange, options, helperText, setSelectedDate, formValues, setFormValues, setFruitesValue, disclaimerText }) => {
    const [selectedOption, setSelectedOption] = useState(value || '');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [details, setDetails] = useState('');
    const [frontImage, setFrontImage] = useState(null);
    const [backImage, setBackImage] = useState(null);
    const [sideImage, setSideImage] = useState(null);
    const [stomachImage, setStomachImage] = useState(null);
    const [thighsImage, setThighsImage] = useState(null);

    const [bodyHeight, setBodyHeight] = useState('');
    const [currentBody, setCurrentBody] = useState('');
    const [targetweight, setTargetweight] = useState('');
    const [bmi, setBmi] = useState(null);
    const [bmiTarget, setBmiTarget] = useState(null);
    const [sliderValue, setSliderValue] = useState(() => parseSliderWeeks(formValues?.sliderValues));
    const [showDiv, setShowDiv] = useState(false); // State to track if div should be shown
    const [calculatedValue, setCalculatedValue] = useState(null); // State to track calculated value

    const frontFileInputRef = useRef(null);
    const backFileInputRef = useRef(null);
    const sideFileInputRef = useRef(null);
    const stomachFileInputRef = useRef(null);
    const thighsFileInputRef = useRef(null);
    const [weightGoal, setWeightGoal] = useState(null); // New state to track weight goal
    const [targetWeightMultiplied, setTargetWeightMultiplied] = useState(null); // New state for multiplied target weight
    const [dividedWeightGoal, setDividedWeightGoal] = useState(null);
    const [adjustedWeightGoal, setAdjustedWeightGoal] = useState(null);
    const [warningMessage, setWarningMessage] = useState(null);
    // Add new state for photo upload error
    const [photoUploadError, setPhotoUploadError] = useState(null);


    const [fruits, setFruits] = useState([
        { name: 'Karotte', value: 0, image: carrot },      // Carrot
        { name: 'Zucchini', value: 0, image: zucchini },  // Zucchini
        { name: 'Apfel', value: 0, image: apple },        // Apple
        { name: 'Avocado', value: 0, image: avacado },    // Avocado
        { name: 'Birne', value: 0, image: pear },         // Pear
        { name: 'Mais', value: 0, image: corn },          // Corn
        { name: 'Ananas', value: 0, image: pineapple },   // Pineapple
        { name: 'Tomate', value: 0, image: tomato },      // Tomato
    ]);

    useEffect(() => {
        // Update the selected option if the value prop changes
        setSelectedOption(value);

    }, [value]);

    useEffect(() => {
        if (name !== "targetWeight") {
            return;
        }

        const weeks = parseSliderWeeks(formValues.sliderValues, null);
        if (weeks !== null) {
            if (sliderValue !== weeks) {
                setSliderValue(weeks);
            }
            return;
        }

        setFormValues((prevValues) => ({
            ...prevValues,
            sliderValues: sliderValue,
        }));
    }, [name, formValues.sliderValues, sliderValue, setFormValues]);

    useEffect(() => {
        console.log("working")
        setFruitesValue(fruits)
    }, [fruits]);

    useEffect(() => {
        if (targetWeightMultiplied && sliderValue) {
            setDividedWeightGoal((targetWeightMultiplied / sliderValue).toFixed(2)); // Calculate divided value
        }
    }, [targetWeightMultiplied, sliderValue]);

    const [fruitsnew, setFruitsnew] = useState([
        { name: 'Karotte', value: 0, image: carrot },      // Carrot
        { name: 'Zucchini', value: 0, image: zucchini },  // Zucchini
        { name: 'Apfel', value: 0, image: apple },        // Apple
        { name: 'Avocado', value: 0, image: avacado },    // Avocado
        { name: 'Birne', value: 0, image: pear },         // Pear
        { name: 'Mais', value: 0, image: corn },          // Corn
        { name: 'Ananas', value: 0, image: pineapple },   // Pineapple
        { name: 'Tomate', value: 0, image: tomato },      // Tomato
    ]);

    // Function to assign fruit points based on BMI
    // const assignFruitPoints = (bmi) => {
    //     let updatedFruits = fruits.map(fruit => ({ ...fruit, value: 0 })); // Reset all points to 0

    //     if (bmi < 19) { // Underweight
    //         updatedFruits = updatedFruits.map(fruit => {
    //             if (fruit.name === 'Karotte' || fruit.name === 'Zucchini') {
    //                 return { ...fruit, value: 1.0 };
    //             } else if (fruit.name === 'Apfel') {
    //                 return { ...fruit, value: 0.5 };
    //             }
    //             return fruit;
    //         });
    //     } else if (bmi >= 19 && bmi <= 24.9) { // Normal weight (Corrected the BMI range to 19-24.9)
    //         updatedFruits = updatedFruits.map(fruit => {
    //             if (['Karotte', 'Zucchini', 'Apfel', 'Avocado', 'Birne', 'Mais'].includes(fruit.name)) {
    //                 return { ...fruit, value: 1.8 };
    //             }
    //             return fruit;
    //         });
    //     } else if (bmi >= 25 && bmi < 30) { // Overweight (added this category for clarity)
    //         updatedFruits = updatedFruits.map(fruit => {
    //             if (['Avocado', 'Ananas', 'Apfel', 'Birne', 'Tomate'].includes(fruit.name)) {
    //                 return { ...fruit, value: 1.0 };
    //             }
    //             return fruit;
    //         });
    //     } else { // Obesity (BMI >= 30)
    //         updatedFruits = updatedFruits.map(fruit => {
    //             if (['Avocado', 'Ananas', 'Tomate'].includes(fruit.name)) {
    //                 return { ...fruit, value: 0.5 };
    //             } else if (fruit.name === 'Apfel') {
    //                 return { ...fruit, value: 0.7 };
    //             }
    //             return fruit;
    //         });
    //     }

    //     setFruitsnew(updatedFruits); // Update local state
    //     setFormValues(prevValues => ({
    //         ...prevValues,
    //         bmifruits: updatedFruits, // Update formValues in parent component
    //     }));

    //     console.log(`BMI: ${bmi}`, updatedFruits);

    // };
    const assignFruitPoints = (bmi) => {
        let updatedFruits = fruits.map(fruit => ({ ...fruit, value: 0 })); // Reset all points to 0

        // if (bmi < 19) { // Untergewicht
        //     updatedFruits = updatedFruits.map(fruit => {
        //         if (fruit.name === 'Karotte' || fruit.name === 'Zucchini') {
        //             return { ...fruit, value: 1.0 };
        //         } else if (fruit.name === 'Apfel') {
        //             return { ...fruit, value: 0.5 };
        //         }
        //         return fruit;
        //     });
        // } else if (bmi >= 19 && bmi <= 23.9) { // Normalgewichtig
        //     updatedFruits = updatedFruits.map(fruit => {
        //         if (['Karotte', 'Zucchini', 'Apfel', 'Avocado', 'Birne', 'Mais'].includes(fruit.name)) {
        //             return { ...fruit, value: 1.0 };
        //         }
        //         return fruit;
        //     });
        // } else if (bmi > 23.9) { // Übergewichtig
        //     updatedFruits = updatedFruits.map(fruit => {
        //         if (['Avocado', 'Ananas', 'Apfel', 'Birne', 'Tomate'].includes(fruit.name)) {
        //             return { ...fruit, value: 1.0 };
        //         }
        //         return fruit;
        //     });
        // }

        setFruitsnew(updatedFruits); // Update local state
        setFormValues(prevValues => ({
            ...prevValues,
            bmifruits: updatedFruits, // Update formValues in parent component
        }));

        console.log(`BMI: ${bmi}`, updatedFruits);
    };

    useEffect(() => {
        const bmiValue = computeBmi(formValues.bodyhight, formValues.currentbody);
        if (bmiValue === null) {
            setBmi(null);
            setFormValues((prev) => {
                if (!prev.bmi) return prev;
                return { ...prev, bmi: "" };
            });
            return;
        }
        const bmiStr = bmiValue.toFixed(2);
        setBmi(bmiStr);
        setFormValues((prev) => {
            if (prev.bmi === bmiStr) return prev;
            return { ...prev, bmi: bmiStr };
        });
        assignFruitPoints(bmiValue.toFixed(1));
    }, [formValues.bodyhight, formValues.currentbody]);

    useEffect(() => {
        const targetWeightStr =
            targetweight !== "" && targetweight != null && targetweight !== undefined
                ? targetweight
                : formValues.targetWeight;
        const bmiTargetValue = computeBmi(formValues.bodyhight, targetWeightStr);
        if (bmiTargetValue === null) {
            setBmiTarget(null);
            setFormValues((prev) => {
                if (!prev.bmiTarget) return prev;
                return { ...prev, bmiTarget: "" };
            });
            return;
        }
        const bmiTargetStr = bmiTargetValue.toFixed(2);
        setBmiTarget(bmiTargetStr);
        setFormValues((prev) => {
            if (prev.bmiTarget === bmiTargetStr) return prev;
            return { ...prev, bmiTarget: bmiTargetStr };
        });
    }, [formValues.bodyhight, formValues.targetWeight, targetweight]);

    useEffect(() => {
        if (name !== "targetWeight") return;
        const bmiValue = computeBmi(formValues.bodyhight, formValues.currentbody);
        const bmiNum = bmiValue !== null ? bmiValue : NaN;
        const current = parseFloat(formValues.currentbody);
        const targetStr =
            targetweight !== "" && targetweight != null && targetweight !== undefined
                ? targetweight
                : formValues.targetWeight;
        const target = parseFloat(targetStr);

        const nextError =
            !Number.isNaN(bmiNum) &&
                bmiNum < 19 &&
                !Number.isNaN(current) &&
                !Number.isNaN(target) &&
                target < current
                ? UNDERWEIGHT_LOSS_NOT_ALLOWED_MESSAGE
                : "";

        setFormValues((prev) => {
            if ((prev.targetWeightValidationError || "") === nextError) return prev;
            return { ...prev, targetWeightValidationError: nextError };
        });
    }, [
        name,
        formValues.bodyhight,
        formValues.currentbody,
        formValues.targetWeight,
        targetweight,
        setFormValues,
    ]);

    const handleWarningMessage = (bmi, goal) => {
        console.log(bmi, goal);
        let message = null; // Placeholder for warning message
        if (bmi < 19) {
            if (goal <= 500) {
                message = "Empfohlen";
            } else if (goal > 500 && goal <= 600) {
                message = "Empfohlen";
            } else if (goal > 600 && goal <= 800) {
                message = "Empfohlen";
            } else if (goal > 800) {
                message = "Kann zu ernsthaften gesundheitlichen Problemen führen!";
            }
        } else if (bmi >= 19 && bmi <= 23.9) {
            if (goal <= 500) {
                message = "Empfohlen";
            } else if (goal > 500 && goal <= 600) {
                message = "Empfohlen";
            } else if (goal > 600 && goal <= 800) {
                message = "Nicht empfohlen!";
            } else if (goal > 800) {
                message = "Kann zu ernsthaften gesundheitlichen Problemen führen!";
            }
        } else if (bmi > 23.9) {
            if (goal <= 500) {
                message = "Nicht empfohlen!";
            } else if (goal > 500 && goal <= 700) {
                message = "Nicht empfohlen!";
            } else if (goal > 700 && goal <= 1000) {
                message = "Nicht empfohlen!";
            } else if (goal > 1000) {
                message = "Kann zu ernsthaften gesundheitlichen Problemen führen!";
            }
        }

        setWarningMessage(message); // Set the message based on the condition
        // Store warning message in formValues so parent component can access it
        setFormValues((prevValues) => ({
            ...prevValues,
            warningMessage: message
        }));
    };
    const handleWarningMessage1 = (bmi, goal) => {
        console.log(bmi, goal);
        let message = null; // Placeholder for warning message

        if (bmi < 19) {
            if (goal <= 500) {
                message = "Kann zu ernsthaften gesundheitlichen Problemen führen!";
            } else if (goal > 500 && goal <= 600) {
                message = "Kann zu ernsthaften gesundheitlichen Problemen führen!";
            } else if (goal > 600 && goal <= 800) {
                message = "Kann zu ernsthaften gesundheitlichen Problemen führen!";
            } else if (goal > 800) {
                message = "Kann zu ernsthaften gesundheitlichen Problemen führen!";
            }
        } else if (bmi >= 19 && bmi <= 23.9) {
            if (goal <= 500) {
                message = "Empfohlen";
            } else if (goal > 500 && goal <= 600) {
                message = "Empfohlen";
            } else if (goal > 600 && goal <= 800) {
                message = "Schwerer zu erreichen";
            } else if (goal > 800) {
                message = "Kann zu ernsthaften gesundheitlichen Problemen führen!";
            }
        } else if (bmi > 23.9) {
            if (goal <= 500) {
                message = "Empfohlen";
            } else if (goal > 500 && goal <= 700) {
                message = "Empfohlen";
            } else if (goal > 700 && goal <= 1000) {
                message = "Schwerer zu erreichen";
            } else if (goal > 1000) {
                message = "Kann zu ernsthaften gesundheitlichen Problemen führen!";
            }
        }

        setWarningMessage(message); // Set the message based on the condition
        // Store warning message in formValues so parent component can access it
        setFormValues((prevValues) => ({
            ...prevValues,
            warningMessage: message
        }));
    };




    const handleHeightChange = (e) => {
        const { value } = e.target;
        setBodyHeight(value);
        onChange(e);
    };

    const handleWeightChange = (e) => {
        const { value } = e.target;
        setCurrentBody(value);
        onChange(e);
    };

    const handleSelectChange = (optionValue) => {
        setSelectedOption(optionValue);
        setIsDropdownOpen(false);
        onChange({ target: { name, value: optionValue } });
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleDetailsChange = (e) => {
        const { value } = e.target;
        setDetails(value);
        onChange({ target: { name: `${name}Details`, value } });
    };

    // const handleFileChange = (e, setImage, targetName) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setImage(reader.result);
    //             onChange({ target: { name: targetName, value: reader.result } });
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };

    const handleFileChange = async (e, setImage, targetName) => {
        const file = e.target.files[0];
        if (file) {
            console.log('Original file:', file); // Log the original file
            // Check file size (20MB)
            if (file.size > 50 * 1024 * 1024) {
                setPhotoUploadError("Die Datei ist zu groß. Bitte laden Sie ein Bild hoch, das kleiner als 50MB ist.");
                return;
            } else {
                setPhotoUploadError(null);
            }

            try {
                const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1024,
                    useWebWorker: true,
                };
                const compressedFile = await imageCompression(file, options);
                console.log('Compressed file:', compressedFile);

                const reader = new FileReader();
                reader.onloadend = () => {
                    setImage(reader.result);
                    onChange({ target: { name: targetName, value: reader.result } });
                };
                reader.readAsDataURL(compressedFile);
            } catch (error) {
                console.error('Image compression error:', error);
                setPhotoUploadError("Bildkomprimierung fehlgeschlagen.");
            }
        }
    };
    const handleWeightTargetChange = (e) => {
        const { value } = e.target;
        setTargetweight(value);
        onChange(e);
        const currentWeight = formValues.currentbody || currentBody;
        const currentBmi = computeBmi(formValues.bodyhight, currentWeight);

        if (value && currentWeight) {
            if (parseFloat(value) > parseFloat(currentWeight)) {
                setWeightGoal("gain");
            } else if (parseFloat(value) < parseFloat(currentWeight)) {
                setWeightGoal("lose");
            } else {
                setWeightGoal("maintain");
            }
        } else {
            setWeightGoal(null);
        }

        setTargetWeightMultiplied(value ? (value * 1000).toFixed(2) : null);

        const difference = Math.abs(parseFloat(currentWeight) - parseFloat(value));
        const adjustedGoal = ((difference * 1000) / sliderValue).toFixed(2);
        setAdjustedWeightGoal(adjustedGoal);

        if (isUnderweightLossBlocked(currentBmi, currentWeight, value)) {
            setWarningMessage(null);
            setFormValues((prevValues) => ({
                ...prevValues,
                warningMessage: null,
            }));
        } else if (parseFloat(value) > parseFloat(currentWeight)) {
            handleWarningMessage(currentBmi, adjustedGoal);
        } else if (parseFloat(value) < parseFloat(currentWeight)) {
            handleWarningMessage1(currentBmi, adjustedGoal);
        } else {
            setWarningMessage(null);
            setFormValues((prevValues) => ({
                ...prevValues,
                warningMessage: null,
            }));
        }
    };




    const handleSliderChange = (event, newValue) => {
        setSliderValue(newValue);

        const currentWeight = formValues.currentbody || currentBody;
        const targetWeightStr = targetweight || formValues.targetWeight;
        const currentBmi = computeBmi(formValues.bodyhight, currentWeight);

        if (currentWeight && targetWeightStr) {
            const difference = Math.abs(parseFloat(currentWeight) - parseFloat(targetWeightStr));
            const adjustedGoal = ((difference * 1000) / newValue).toFixed(2);
            setAdjustedWeightGoal(adjustedGoal);

            if (isUnderweightLossBlocked(currentBmi, currentWeight, targetWeightStr)) {
                setWarningMessage(null);
                setFormValues((prevValues) => ({
                    ...prevValues,
                    warningMessage: null,
                }));
            } else if (parseFloat(targetWeightStr) > parseFloat(currentWeight)) {
                handleWarningMessage(currentBmi, adjustedGoal);
            } else if (parseFloat(targetWeightStr) < parseFloat(currentWeight)) {
                handleWarningMessage1(currentBmi, adjustedGoal);
            } else {
                setWarningMessage(null);
                setFormValues((prevValues) => ({
                    ...prevValues,
                    warningMessage: null,
                }));
            }
        }

        setFormValues((prevValues) => ({
            ...prevValues,
            sliderValues: newValue,
        }));
    };
    const handleInputChange = (e) => {
        var { value } = e.target;
        onChange(e); // Update parent state

        // Show div if value is greater than 300
        if (value > 300) {
            setShowDiv(true); // Show the div if value is greater than 300
        } else {
            setShowDiv(false); // Hide the div otherwise
            setCalculatedValue(null); // Clear calculated value if less than 300
            return; // Stop further execution if value is less than 300
        }
        value = parseFloat(value);
        // Check value and show specific number in the div if greater than 5000
        if (formValues.stepseveryday === "Nein") {
            value += value * 0.25;
        }


        let calculated = null;
        console.log(value, '>>>>>>>>>>>>>>>>>>>')
        if (value < 5000) {
            calculated = 1.35;
        } else if (value >= 5000 && value < 6000) {
            calculated = 1.4;
        } else if (value >= 6000 && value < 7000) {
            calculated = 1.45;
        } else if (value >= 7000 && value < 8000) {
            calculated = 1.5;
        } else if (value >= 8000 && value < 9000) {
            calculated = 1.55;
        } else if (value >= 9000 && value < 10000) {
            calculated = 1.55;
        } else if (value >= 10000 && value < 12000) {
            calculated = 1.6;
        } else if (value >= 12000 && value < 12500) {
            calculated = 1.6;
        } else if (value >= 12500 && value < 15000) {
            calculated = 1.7;
        } else if (value >= 15000 && value < 20000) {
            calculated = 1.8;
        } else if (value >= 20000) {
            calculated = 2;
        } else {
            calculated = null; // Clear the div if value is less than 5000
        }

        // setCalculatedValue(calculated);

        // Update formValues in App.js
        // setFormValues((prevValues) => ({
        //     ...prevValues,
        //     [name]: value,          
        //     calculatedValue: calculated, 
        // }));
    };

    const getPlaceholder = () => {
        switch (name) {
            case "name":
                return "Max Muster  ";
            case "dateOfBirth":
                return "Select your date of birth";
            case "Email":
                return "Name@beispiel.com";
            case "bodyhight":
                return "170";
            case "currentbody":
                return "70";
            case "myperseverance":
                return "5";
            case "dietwithtimestamp":
                return "Tag 1 (Wochentag) \n\
08:00 Uhr: Joghurt mit Beeren \n\
12:30 Uhr: Salat mit Hähnchen \n\
15:00 Uhr: Apfel \n\
19:00 Uhr: Reis mit Gemüse\n\
Tag 2 (Wochentag)\n\
\n\
07:30 Uhr: Haferflocken mit Banane\n\
13:00 Uhr: Sandwich\n\
16:00 Uhr: Nüsse\n\
18:30 Uhr: Pasta mit Tomatensauce\n\
Tag 3 (Wochenende)\n\
\n\
09:00 Uhr: Rührei mit Toast\n\
14:00 Uhr: Burger\n\
17:00 Uhr: Joghurt\n\
19:30 Uhr: Pizza";
            case "about":
                return "In letzter Zeit fühle ich mich in meinem Körper nicht mehr wohl und habe Schwierigkeiten, mein Wunschgewicht zu erreichen. Trotz eigener Bemühungen fehlt mir oft die Motivation, die richtigen Entscheidungen bei Ernährung und Bewegung zu treffen. Daher suche ich professionelle Unterstützung, um meine Ziele nachhaltig zu erreichen.";
            case "mygoals":
                return "Mein Hauptziel ist es, mein Gewicht zu reduzieren und einen gesunden Lebensstil zu etablieren. Ich möchte mich fitter und energiegeladener fühlen, meine Ausdauer verbessern und langfristig ein besseres Körpergefühl erreichen. Darüber hinaus ist es mir wichtig, gesunde Gewohnheiten zu entwickeln, die ich dauerhaft beibehalten kann.";
            case "youdrink":
                return "Morgens trinke ich etwa 250 ml Kaffee und ein Glas Wasser (300 ml). Über den Tag verteilt trinke ich ca. 1,5 Liter Wasser und nachmittags nochmal eine Tasse Tee (200 ml). Abends trinke ich meistens noch ein Glas Wasser (300 ml).";
            case "craving":
                return "Ja, ich bekomme oft Heisshunger am späten Nachmittag, meist gegen 16:00 Uhr. In diesen Situationen greife ich häufig zu Schokolade oder Chips";
            case "myallergies":
                return "Ich bin allergisch gegen Nüsse und Gluten. Bei Nusskontakt bekomme ich Hautausschlag, und bei glutenhaltigen Lebensmitteln habe ich Magenbeschwerden.";
            case "orderperweek":
                return "";
            case "eatingperweek":
                return "Ich esse etwa 3-4 Mal pro Woche auswärts. Dazu zählen ein Mittagessen in der Mensa, einmal Abendessen bei meinen Eltern, und ab und zu hole ich mir etwas vom Bäcker zum Frühstück.";
            case "attentionyourdiet":
                return "Ich versuche, darauf zu achten, nicht zu viel Zucker zu essen und zumindest ein bisschen Gemüse in meine Mahlzeiten einzubauen. Es ist mir auch wichtig, regelmässig zu essen, aber manchmal greife ich auch zu schnellen Snacks oder Fertigprodukten, wenn ich wenig Zeit habe.";
            case "trainperweek":
                return "Ich trainiere etwa 2-3 Mal pro Woche. Meistens gehe ich joggen für etwa 30 Minuten oder mache ein Workout zu Hause für ca. 45 Minuten. Ab und zu nehme ich an einem Yoga-Kurs teil, der etwa eine Stunde dauert.";
            case "traintotal":
                return "180";
            case "MeTime":
                return "Bei Stress gehe ich gerne eine Runde spazieren oder höre Musik, um abzuschalten. Manchmal greife ich auch zu einem Stück Schokolade oder rede mit einem Freund, um den Kopf frei zu bekommen.";
            case "proTag":
                return "Ich bin grösstenteils zufrieden in meinem Job. Die Arbeit ist interessant, und ich verstehe mich gut mit meinen Kollegen. Manchmal gibt es stressige Phasen, aber insgesamt fühle ich mich wohl und schätze die Sicherheit und die Entwicklungsmöglichkeiten.";

            case "Schritte":
                return "Ich habe meistens etwa 30 Minuten bis eine Stunde Me-Time pro Tag. Diese Zeit nutze ich, um ein Buch zu lesen, spazieren zu gehen oder einfach mal zu entspannen";

            case "beiStress":
                return "Ich arbeite als Marketing-Managerin in einem mittelständischen Unternehmen. Ich bin zu 80% angestellt, was sich auf vier Tage pro Woche verteilt. Meistens arbeite ich montags bis donnerstags, jeweils von 8:00 bis 17:00 Uhr.";
            case "zufrieden":
                return "Ich schlafe normalerweise etwa 6-7 Stunden pro Nacht. Unter der Woche gehe ich meistens gegen 23:00 Uhr ins Bett und stehe um 6:00 Uhr auf. Am Wochenende versuche ich, etwas länger zu schlafen, um den Schlafmangel auszugleichen.";
            case "wieverteilt":
                return "Meine Schlafqualität ist meistens okay, aber nicht perfekt. Oft wache ich in der Nacht ein- oder zweimal auf und brauche dann etwas Zeit, um wieder einzuschlafen. Morgens fühle ich mich manchmal noch müde, besonders wenn ich Stress habe oder spät ins Bett gehe.";
            case "verteilt":
                return "Ja, ich fühle mich oft tagsüber müde und energielos, besonders nach dem Mittagessen. Es fällt mir dann schwer, mich auf meine Aufgaben zu konzentrieren, und ich hätte gerne mehr Energie, um produktiver zu sein.";
            case "Schlafdauer":
                return "Meine Verdauung ist meistens in Ordnung, aber hin und wieder habe ich mit Blähungen oder einem Völlegefühl zu kämpfen. Gelegentlich habe ich auch Verstopfungen, besonders wenn ich nicht genug Wasser trinke oder mich wenig bewege.";
            case "Schlafqualität":
                return "Mein Zyklus ist ziemlich regelmässig und dauert meistens 28 bis 30 Tage. Ab und zu verschiebt er sich um ein paar Tage, besonders wenn ich gestresst bin oder meine Routine sich ändert.";
            case "energielos":
                return "Für meine Regeneration nehme ich mir nach dem Training meistens Zeit für Dehnübungen, etwa 10-15 Minuten. Einmal pro Woche gönne ich mir ein heisses Bad oder gehe in die Sauna, um meine Muskeln zu entspannen. Ausserdem versuche ich, regelmässig genügend Schlaf zu bekommen, um meinem Körper die nötige Erholung zu geben.";
            case "Verdauung":
                return "Ich stehe etwa einmal pro Woche auf die Waage, meistens am Morgen, um mein Gewicht im Blick zu behalten. Manchmal lasse ich es auch länger, wenn ich mich nicht zu sehr darauf konzentrieren möchte.";
            case "Regeneration":
                return "Vor drei Jahren hatte ich eine Knieoperation aufgrund eines Meniskusschadens. Ausserdem leide ich an einer Schilddrüsenunterfunktion, die medikamentös behandelt wird. Beide sind wichtig zu berücksichtigen, wenn es um meine Fitness und Ernährung geht.";
            case "stehst":
                return "Ich nehme täglich eine Tablette zur Schilddrüsenhormonregulation (L-Thyroxin 50 mg). Ausserdem nehme ich gelegentlich Ibuprofen bei starken Kopfschmerzen oder Schmerzen nach dem Training.";
            case "Erkrankungen":
                return "Meine grössten Fehlerquellen sind unregelmässiges Essen und häufige Snacks zwischendurch, besonders wenn ich gestresst bin. Ausserdem fehlt mir manchmal die Disziplin, regelmässig zu trainieren, und ich neige dazu, auf schnelle, ungesunde Optionen zurückzugreifen, wenn ich wenig Zeit habe.";
            case "heartrate":
                return "70";
            case "uploadphotos":
                return "Upload your photos";
            case "averageperday":
                return "8000";


            default:
                return "";
        }
    };

    // const [selectedDate, setSelectedDate] = useState(null);

    const handleDateChange = (date) => {
        console.log("Selected date: ", date); // Do something with the date
        setSelectedDate(date); // Update the state in the parent component
    };
    return (
        <div className='form'>
            <label className='form-tag typography-title-small'>
                {label}

                {helperText && <div className='helper-text'>{helperText}</div>}
                {disclaimerText && <div className='helper-text'>{disclaimerText}</div>}

                {name === "dateOfBirth" ? (
                    <>
                        <CustomDatePicker onDateChange={handleDateChange} selectedDate={formValues.dateOfBirth} />
                        <div className='gender-select' style={{ marginTop: '24px' }}>
                            <div>Geschlecht</div>
                            {["Weiblich", "Männlich"].map((g) => (
                                <label key={g} style={{ marginRight: '24px' }}>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value={g}
                                        checked={formValues.gender === g}
                                        onChange={() => setFormValues((prev) => ({ ...prev, gender: g }))}
                                    />{" "}
                                    {g}
                                </label>
                            ))}
                        </div>
                    </>
                ) : name === "bodyhight" ? (
                    <input
                        // className='tissue-legs-text-area'
                        type="number"
                        name={name}
                        value={bodyHeight || value}

                        onChange={handleHeightChange}
                        placeholder={getPlaceholder()}

                    />


                )
                    : name === "currentbody" ? (
                        <>

                            <input
                                // className='tissue-legs-text-area'
                                type="number"
                                name={name}
                                value={currentBody || value}
                                onChange={handleWeightChange}
                                placeholder={getPlaceholder()}

                            />

                            {bmi && (
                                <div className='bmi' style={{ display: 'none' }} >
                                    <label>BMI:</label>
                                    <span>{formValues.bmi}</span>
                                </div>
                            )}
                        </>

                    )
                        : name === "myperseverance" ? (
                            <input
                                // className='tissue-legs-text-area'
                                type="number"
                                name={name}
                                value={value}
                                min="1"
                                max="10"
                                onChange={onChange}
                                placeholder={getPlaceholder()}
                                onInput={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (value < 1) {
                                        e.target.value = 1;
                                    } else if (value > 10) {
                                        e.target.value = 10;
                                    }
                                }}
                            />
                        )
                            // : name === "bodyhight" ? (
                            //     <input
                            //         // className='tissue-legs-text-area'
                            //         type="number"
                            //         name={name}
                            //         min="1"
                            //         max="10"
                            //         onChange={onChange}
                            //         placeholder={getPlaceholder()}
                            //         onInput={(e) => {
                            //             const value = parseInt(e.target.value, 10);
                            //             if (value < 1) {
                            //                 e.target.value = 1;
                            //             } else if (value > 10) {
                            //                 e.target.value = 10;
                            //             }
                            //         }}
                            //     />
                            // )
                            : name === "traintotal" ? (
                                <>
                                    <input
                                        type="number"
                                        name={name}
                                        value={value}
                                        min="1"
                                        onChange={handleInputChange} // Use custom change handler
                                        placeholder={getPlaceholder()}
                                    />


                                    {/* Conditionally render the div with paragraphs */}
                                    {showDiv && (
                                        // <div className='glasses-alcohol'>
                                        //     <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                        //         <p>
                                        //             Birne
                                        //         </p>
                                        //         <img style={{ width: '35px' }}
                                        //             src={pear}
                                        //             alt="Front Photo"
                                        //         />
                                        //     </div>
                                        //     <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        //         <p>
                                        //             Ananas
                                        //         </p>
                                        //         <img style={{ width: '35px' }}
                                        //             src={pineapple}
                                        //             alt="Front Photo"
                                        //         />
                                        //     </div>
                                        //     <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        //         <p>
                                        //             Mais
                                        //         </p>
                                        //         <img style={{ width: '35px' }}
                                        //             src={corn}
                                        //             alt="Front Photo"
                                        //         />
                                        //     </div>
                                        //     <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        //         <p>
                                        //             Zucchini
                                        //         </p>
                                        //         <img style={{ width: '35px' }}
                                        //             src={zucchini}
                                        //             alt="Front Photo"
                                        //         />
                                        //     </div>
                                        // </div>
                                        <div className='glasses-alcohol'>
                                            <div className='fruits-section'>
                                                {/* <h3>Recommended Fruits Based on Your BMI:</h3> */}
                                                <div className='fruits-list'>
                                                    {fruits.map(fruit => {
                                                        // Check if the fruit should be displayed based on your criteria
                                                        if (['Birne', 'Ananas', 'Mais', 'Zucchini'].includes(fruit.name)) {
                                                            return (
                                                                <div key={fruit.name} className='fruit-item'>

                                                                    <p style={{ width: 'auto' }} >{fruit.value}</p>
                                                                    <p>{fruit.name}</p>
                                                                    <img src={fruit.image} alt={fruit.name} style={{ width: '35px' }} />
                                                                </div>
                                                            );
                                                        }
                                                        return null; // Return null for fruits that shouldn't be displayed
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )
                                : name === "averageperday" ? (
                                    <>
                                        <input
                                            type="number"
                                            name={name}
                                            value={value}
                                            min="1"
                                            max="10000"
                                            onChange={handleInputChange} // Use updated handler
                                            placeholder="Geben Sie eine Nummer ein"
                                        />

                                        {/* {showDiv && calculatedValue !== null && (
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'none' }}>
                                                Pal Wert: {calculatedValue}
                                            </div>
                                        )} */}
                                    </>
                                )

                                    : name === "targetWeight" ? (
                                        <div className='target-weight-container'>
                                            <div className='target-weight-fields'>
                                                <div>
                                                    <p>
                                                        Aktuelles Gewicht in kg
                                                    </p>

                                                    <input style={{ margin: '0px' }}
                                                        disabled
                                                        type="number"
                                                        name={name}
                                                        value={currentBody || value}
                                                        onChange={handleWeightChange}
                                                        placeholder='60'
                                                    />
                                                </div>
                                                {/* <h3>KG</h3> */}
                                                <img src={weightarrow} alt="Weight Arrow" className='weight-arrow' />

                                                <div>
                                                    <p>
                                                        Zielgewicht in kg
                                                    </p>
                                                    <input style={{ margin: '0px' }}
                                                        type="number"
                                                        name={name}
                                                        value={targetweight}
                                                        min={30}
                                                        max={300}
                                                        step="0.1"
                                                        onChange={handleWeightTargetChange}
                                                        placeholder='55'
                                                    />

                                                </div>



                                                {/* <h3>KG</h3> */}
                                            </div>
                                            {warningMessage && (
                                                <div style={{ color: 'red', fontWeight: 'bold', marginTop: '10px' }}>
                                                    {warningMessage}
                                                </div>
                                            )}
                                            {formValues.targetWeightValidationError && (
                                                <div style={{ color: 'red', fontWeight: 'bold', marginTop: '10px', whiteSpace: 'pre-line' }}>
                                                    {formValues.targetWeightValidationError}
                                                </div>
                                            )}
                                            {/* {adjustedWeightGoal && (
                                                <p>
                                                    Adjusted Weight Goal (based on slider): {adjustedWeightGoal} g
                                                </p>
                                            )} */}
                                            {/* {weightGoal === "gain" && (
                                                <p style={{ color: 'green' }}>
                                                    Goal: Weight Gain   {dividedWeightGoal}
                                                </p>
                                            )}
                                            {weightGoal === "lose" && (
                                                <p style={{ color: 'red' }}>
                                                    Goal: Weight Loss   {dividedWeightGoal}
                                                </p>
                                            )}
                                            {weightGoal === "maintain" && (
                                                <p style={{ color: 'blue' }}>
                                                    Goal: Maintain Weight   {dividedWeightGoal}
                                                </p>
                                            )} */}
                                            {bmi && (
                                                <div className='bmi' style={{ justifyContent: "center", display: 'none' }} >
                                                    <label>BMI:</label>
                                                    <span>{formValues.bmiTarget}</span>
                                                </div>
                                            )}
                                            <div className="slider-container">
                                                <div className="weight-display">
                                                    <span>Geplante Wochen zur Erreichung des Zielgewichts: {sliderValue} Woche</span>
                                                </div>
                                            </div>
                                            <Slider
                                                defaultValue={10}
                                                aria-label="Default"
                                                valueLabelDisplay="auto"
                                                min={1}
                                                max={52}
                                                value={sliderValue} // Use the new slider state
                                                onChange={handleSliderChange}
                                            />
                                        </div>
                                    ) : name === "mygoals" || name === "myallergies" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                placeholder={getPlaceholder()}
                                                rows="6"
                                            />
                                        </div>
                                    ) : name === "about" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "craving" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "youdrink" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "eatingperweek" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "attentionyourdiet" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "trainperweek" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "MeTime" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "proTag" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "Schritte" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "beiStress" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "zufrieden" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "wieverteilt" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "verteilt" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "Schlafdauer" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "Schlafqualität" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "energielos" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "Regeneration" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "dietwithtimestamp" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "Verdauung" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "stehst" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    ) : name === "Erkrankungen" ? (
                                        <div>
                                            <textarea
                                                className='tissue-legs-text-area'
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                rows="6"
                                                placeholder={getPlaceholder()}
                                            />
                                        </div>
                                    )
                                        : name === "heartrate" ? (
                                            <div>
                                                <div className='finger-section'>
                                                    <img src={finger} alt="f2" className='finger-img' />
                                                    <p className='typography-title-small'>
                                                        Einfach zwei oder drei Finger auf die Innenseite des Handgelenks unterhalb des Daumens legen und 30 Sekunden lang die Schläge mitzählen. Der Wert mal zwei ergibt den Puls pro Minute.
                                                    </p>
                                                </div>
                                                <input
                                                    style={{ marginTop: '20px !important' }}
                                                    // className='tissue-legs-text-area'
                                                    type="number"
                                                    name={name}
                                                    value={value}
                                                    min="1"
                                                    max="10"
                                                    onChange={onChange}
                                                    placeholder={getPlaceholder()}

                                                />

                                            </div>
                                        ) : name === "uploadphotos" ? (
                                            <div className='profile-img-main-box-responsive'>

                                                {photoUploadError && (
                                                    <div style={{ color: 'red', fontWeight: 'bold', marginBottom: '10px' }}>
                                                        {photoUploadError}
                                                    </div>
                                                )}
                                                <div className='profile-img-main-box'>
                                                    <div className='photo-main'>
                                                        <p className="typography-body-large">Frontansicht </p>
                                                        <label>
                                                            <img
                                                                className='upload-img'
                                                                src={frontImage || frontimg}
                                                                alt="Front Photo"
                                                            />
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                style={{ display: 'none' }}
                                                                ref={frontFileInputRef}
                                                                onChange={(e) => handleFileChange(e, setFrontImage, `${name}Front`)}
                                                            />
                                                        </label>
                                                    </div>
                                                    <div className='photo-main'>
                                                        <p className="typography-body-large">Rückansicht</p>
                                                        <label>
                                                            <img
                                                                className='upload-img'
                                                                src={backImage || backimg}
                                                                alt="Back Photo"
                                                            />
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                style={{ display: 'none' }}
                                                                ref={backFileInputRef}
                                                                onChange={(e) => handleFileChange(e, setBackImage, `${name}Back`)}
                                                            />
                                                        </label>
                                                    </div>
                                                    <div className='photo-main'>
                                                        <p className="typography-body-large">Seitenansicht</p>
                                                        <label>
                                                            <img
                                                                className='upload-img'
                                                                src={sideImage || sideimg}
                                                                alt="Side Photo"
                                                            />
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                style={{ display: 'none' }}
                                                                ref={sideFileInputRef}
                                                                onChange={(e) => handleFileChange(e, setSideImage, `${name}Side`)}
                                                            />
                                                        </label>
                                                    </div>
                                                    <div className='photo-main'>
                                                        <p className="typography-body-large">Bauchansicht</p>
                                                        <label>
                                                            <img
                                                                className='upload-img'
                                                                src={stomachImage || stomachimg}
                                                                alt="Stomach Photo"
                                                            />
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                style={{ display: 'none' }}
                                                                ref={stomachFileInputRef}
                                                                onChange={(e) => handleFileChange(e, setStomachImage, `${name}Stomach`)}
                                                            />
                                                        </label>
                                                    </div>
                                                    <div className='photo-main'>
                                                        <p className="typography-body-large">Oberschenkelansicht </p>
                                                        <label>
                                                            <img
                                                                className='upload-img'
                                                                src={thighsImage || thighsimg}
                                                                alt="Thighs Photo"
                                                                style={{ objectFit: 'contain', display: 'inline' }}
                                                            />
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                style={{ display: 'none' }}
                                                                ref={thighsFileInputRef}
                                                                onChange={(e) => handleFileChange(e, setThighsImage, `${name}Thighs`)}
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : options ? (
                                            <>
                                                <div className="custom-select-wrapper">
                                                    <div
                                                        className="custom-select"
                                                        onClick={toggleDropdown}
                                                    >
                                                        <div className="selected-option">
                                                            {selectedOption ? options.find(option => option.value === selectedOption)?.label : 'Option auswählen...'}
                                                        </div>
                                                        <div>
                                                            <div className={`options-list ${isDropdownOpen ? 'open' : ''}`}>
                                                                {options.map(option => (
                                                                    <div
                                                                        key={option.value}
                                                                        className={`custom-option ${selectedOption === option.value ? 'selected' : ''}`}
                                                                        onClick={() => handleSelectChange(option.value)}
                                                                    >
                                                                        {option.label}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Fruits Section Based on BMI */}
                                                {/* <div className='fruits-section'>
                                                    <h3>Recommended Fruits Based on Your BMI:</h3>
                                                    <div className='fruits-list'>
                                                        {fruits.map(fruit => (
                                                            <div key={fruit.name} className='fruit-item'>
                                                                <img src={fruit.image} alt={fruit.name} style={{ width: '35px' }} />
                                                                <p>{fruit.value}</p>
                                                                <p>{fruit.name}</p>

                                                            </div>
                                                        ))}
                                                    </div>
                                                </div> */}
                                                {/* {console.log(selectedOption)} */}
                                                {selectedOption === "1-2 Gläser" && (
                                                    <div className='glasses-alcohol'>
                                                        <div className='fruits-section'>
                                                            {/* <h3>Recommended Fruits Based on Your BMI:</h3> */}
                                                            <div className='fruits-list'>
                                                                {fruits.map(fruit => {
                                                                    // Check if the fruit should be displayed based on your criteria
                                                                    if (['Avocado', 'Karotte', 'Ananas', 'Tomate', 'Apfel'].includes(fruit.name)) {
                                                                        return (
                                                                            <div key={fruit.name} className='fruit-item'>

                                                                                <p style={{ width: 'auto' }} >{fruit.value}</p>
                                                                                <p>{fruit.name}</p>
                                                                                <img src={fruit.image} alt={fruit.name} style={{ width: '35px' }} />
                                                                            </div>
                                                                        );
                                                                    }
                                                                    return null; // Return null for fruits that shouldn't be displayed
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}


                                                {selectedOption === "3-4 Gläser" && (
                                                    <div className='glasses-alcohol'>
                                                        <div className='fruits-section'>
                                                            {/* <h3>Recommended Fruits Based on Your BMI:</h3> */}
                                                            <div className='fruits-list'>
                                                                {fruits.map(fruit => {
                                                                    // Check if the fruit should be displayed based on your criteria
                                                                    if (['Avocado', 'Karotte', 'Ananas', 'Tomate', 'Apfel'].includes(fruit.name)) {
                                                                        return (
                                                                            <div key={fruit.name} className='fruit-item'>

                                                                                <p style={{ width: 'auto' }}>{fruit.value}</p>
                                                                                <p>{fruit.name}</p>
                                                                                <img src={fruit.image} alt={fruit.name} style={{ width: '35px' }} />
                                                                            </div>
                                                                        );
                                                                    }
                                                                    return null; // Return null for fruits that shouldn't be displayed
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}


                                                {/* {selectedOption == "3-4 Gläser" &&
                                                    <div className='glasses-alcohol'>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                                            <p>
                                                                Avocado
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={avacado}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Apfel
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={apple}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Karotte
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={carrot}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Tomate
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={tomato}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Ananas
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={pineapple}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                    </div>
                                                } */}

                                                {selectedOption === "5 und mehr Gläser" && (
                                                    <div className='glasses-alcohol'>
                                                        <div className='fruits-section'>
                                                            {/* <h3>Recommended Fruits Based on Your BMI:</h3> */}
                                                            <div className='fruits-list'>
                                                                {fruits.map(fruit => {
                                                                    // Check if the fruit should be displayed based on your criteria
                                                                    if (['Avocado', 'Tomate', 'Apfel'].includes(fruit.name)) {
                                                                        return (
                                                                            <div key={fruit.name} className='fruit-item'>

                                                                                <p style={{ width: 'auto' }}>{fruit.value}</p>
                                                                                <p>{fruit.name}</p>
                                                                                <img src={fruit.image} alt={fruit.name} style={{ width: '35px' }} />
                                                                            </div>
                                                                        );
                                                                    }
                                                                    return null; // Return null for fruits that shouldn't be displayed
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {/* {selectedOption == "5 und mehr Gläser" &&
                                                    <div className='glasses-alcohol'>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                                            <p>
                                                                Avocado
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={avacado}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Apfel
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={apple}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Tomate
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={tomato}
                                                                alt="Front Photo"
                                                            />
                                                        </div>

                                                    </div>
                                                } */}

                                                {selectedOption === "Ich trinke kein Alkohol" && (
                                                    <div className='glasses-alcohol'>
                                                        <div className='fruits-section'>
                                                            {/* <h3>Recommended Fruits Based on Your BMI:</h3> */}
                                                            <div className='fruits-list'>
                                                                {fruits.map(fruit => {
                                                                    // Check if the fruit should be displayed based on your criteria
                                                                    if (['Zucchini', 'Birne', 'Mais'].includes(fruit.name)) {
                                                                        return (
                                                                            <div key={fruit.name} className='fruit-item'>

                                                                                <p style={{ width: 'auto' }} >{fruit.value}</p>
                                                                                <p>{fruit.name}</p>
                                                                                <img src={fruit.image} alt={fruit.name} style={{ width: '35px' }} />
                                                                            </div>
                                                                        );
                                                                    }
                                                                    return null; // Return null for fruits that shouldn't be displayed
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {/* {selectedOption == "Ich trinke kein Alkohol" &&
                                                    <div className='glasses-alcohol'>

                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                                            <p>
                                                                Zucchini
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={zucchini}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Birne
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={pear}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Mais
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={corn}
                                                                alt="Front Photo"
                                                            />
                                                        </div>


                                                    </div>
                                                } */}

                                                {selectedOption === "ja1" && (
                                                    <div className='glasses-alcohol'>
                                                        <div className='fruits-section'>
                                                            {/* <h3>Recommended Fruits Based on Your BMI:</h3> */}
                                                            <div className='fruits-list'>
                                                                {fruits.map(fruit => {
                                                                    // Check if the fruit should be displayed based on your criteria
                                                                    if (['Ananas', 'Birne', 'Zucchini', 'Mais'].includes(fruit.name)) {
                                                                        return (
                                                                            <div key={fruit.name} className='fruit-item'>

                                                                                <p style={{ width: 'auto' }} >{fruit.value}</p>
                                                                                <p>{fruit.name}</p>
                                                                                <img src={fruit.image} alt={fruit.name} style={{ width: '35px' }} />
                                                                            </div>
                                                                        );
                                                                    }
                                                                    return null; // Return null for fruits that shouldn't be displayed
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {/* {selectedOption == "ja1" &&
                                                    <div className='glasses-alcohol'>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                                            <p>
                                                                Ananas
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={pineapple}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Birne
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={pear}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Zucchini
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={zucchini}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Mais
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={corn}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                    </div>
                                                } */}

                                                {selectedOption === "Nein1" && (
                                                    <div className='glasses-alcohol'>
                                                        <div className='fruits-section'>
                                                            {/* <h3>Recommended Fruits Based on Your BMI:</h3> */}
                                                            <div className='fruits-list'>
                                                                {fruits.map(fruit => {
                                                                    // Check if the fruit should be displayed based on your criteria
                                                                    if (['Avocado', 'Apfel', 'Karotte', 'Tomate'].includes(fruit.name)) {
                                                                        return (
                                                                            <div key={fruit.name} className='fruit-item'>

                                                                                <p style={{ width: 'auto' }} >{fruit.value}</p>
                                                                                <p>{fruit.name}</p>
                                                                                <img src={fruit.image} alt={fruit.name} style={{ width: '35px' }} />
                                                                            </div>
                                                                        );
                                                                    }
                                                                    return null; // Return null for fruits that shouldn't be displayed
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* {selectedOption == "Nein1" &&
                                                    <div className='glasses-alcohol'>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                                            <p>
                                                                Avocado
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={avacado}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Apfel
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={apple}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Karotte
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={carrot}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <p>
                                                                Tomate
                                                            </p>
                                                            <img style={{ width: '35px' }}
                                                                src={tomato}
                                                                alt="Front Photo"
                                                            />
                                                        </div>
                                                    </div>
                                                } */}



                                                {/* <select className='form-select-drop' name={name} value={selectedOption} onChange={handleSelectChange} style={{ background: '#ffff' }}>
                                    {options.map(option => (
                                        <option className='form-select-option' key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select> */}

                                            </>
                                        ) : (
                                            <input
                                                // className='tissue-legs-text-area'
                                                type="text"
                                                name={name}
                                                value={value}
                                                onChange={onChange}
                                                placeholder={getPlaceholder()}

                                            />
                                        )}
            </label>
        </div>
    );
};

export default Form;





